import React, { useState } from "react"
import * as Yup from "yup"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Form,
  Input,
  FormFeedback,
  Button,
} from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useCreatePermissionMutation } from "store/api/permissions/permissions.api"
import { useFormik } from "formik"
import { Link, useNavigate } from "react-router-dom"
import leftArrow from "../../assets/images/icons/left-arrow.svg"
import DownArrowColor from "../../assets/images/icons/down-arrow-color.svg"
import UpArrowColor from "../../assets/images/icons/up-arrow-color.svg"
import users from "../../assets/images/icons/users.svg"
import bag from "../../assets/images/icons/bag.svg"
import conversion from "../../assets/images/icons/conversion-rate.svg"
import investor from "../../assets/images/icons/investor.svg"
import user from "../../assets/images/icons/user.svg"
import wallet from "../../assets/images/icons/wallet.svg"
import file from "../../assets/images/icons/file-type.svg"
import check from "../../assets/images/icons/right-check.svg"
import documentfile from "../../assets/images/icons/document.svg"

const RequestsViewREITs = () => {
  const navigate = useNavigate()
  const [mutate] = useCreatePermissionMutation()
  //meta title
  document.title = "Wealth Partner Details"

  const onFormSubmit = async (values) => {
    try {
      const response = await mutate(values).unwrap()
      if (response.success) {
        navigate("/reits")
      }
    } catch (error) {}
  }

  const horizontalformik = useFormik({
    initialValues: {
      module: "",
      key: "",
      label: "",
    },
    validationSchema: Yup.object({}),

    onSubmit: (values) => {
      onFormSubmit(values)
    },
  })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <div className="d-flex align-items-center gap-2 mb-4">
            <Link to={"/reits/requests"}>
              <img src={leftArrow} alt="" />
            </Link>
            <div className="page-title-name">REIT Request Detail</div>
          </div>
          {/* <Breadcrumbs
              title={"Wealth Partner Details"}
              breadcrumbItem={"Wealth Partner Details"}
            /> */}
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Request Info</CardTitle>
                  <Form onSubmit={horizontalformik.handleSubmit}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">Request ID</Label>
                        <Input
                          disabled
                          name="code"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Request ID"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Requested By
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Requested By"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Request Date
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Request Date"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Status
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Status"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Issuer Details</CardTitle>
                  <Form onSubmit={horizontalformik.handleSubmit}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">Issuer Name</Label>
                        <Input
                          disabled
                          name="code"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Issuer Name"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          CIN
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="CIN"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Credit Rating
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Credit Rating"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Sector
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Sector"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Bond Information</CardTitle>
                  <Form onSubmit={horizontalformik.handleSubmit}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Bond Series Name
                        </Label>
                        <Input
                          disabled
                          name="code"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Bond Series Name"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Face Value
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Face Value"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Coupon Rate
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Coupon Rate"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Tenure
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Tenure"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Minimum Investment
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Minimum Investment"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Interest Payment Frequency
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Interest Payment Frequency"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Listing Type
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Listing Type"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Total Issuance Size
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="text"
                          className="form-control"
                          id="horizontal-email-id "
                          placeholder="Total Issuance Size"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl={12}>
              <CardTitle className="pb-4">Documents Uploaded</CardTitle>
              <div className="documents-section">
                <div className="documents-box">
                  <div className="file-type">
                    <img src={file} alt="" />
                    <p>Investment Agreement.pdf</p>
                  </div>
                  <div className="verified-user">
                    <img src={check} alt="" /> Verified
                  </div>
                </div>
                <div className="documents-box">
                  <div className="file-type">
                    <img src={file} alt="" />
                    <p>Offer Document.pdf</p>
                  </div>
                  <div className="verified-user">
                    <img src={check} alt="" /> Verified
                  </div>
                </div>
                <div className="documents-box">
                  <div className="file-type">
                    <img src={file} alt="" />
                    <p>Term Sheet.pdf</p>
                  </div>
                  <div className="verified-user">
                    <img src={check} alt="" /> Verified
                  </div>
                </div>
              </div>
              <div className="buttons">
                <Button className="reject">Reject Request</Button>
                <Button className="approve">Approve Request</Button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default RequestsViewREITs
